import { Screen } from '~/screens/clients/new';

export const ClientsNew: React.FC = () => <Screen />;
